export const LOAD_FORM = 'toxProfileItemForm/LOAD_FORM';
export const SAVE_BUTTON_CLICK = 'toxProfileItemForm/SAVE_BUTTON_CLICK';
export const ADD_TOXPROFILEITEM = 'toxProfileItemForm/ADD_TOXPROFILEITEM';
export const SELECT_TOXPROFILEITEM = 'toxProfileItemForm/SELECT_TOXPROFILEITEM';
export const DELETE_BUTTON_CLICK = 'toxProfileItemForm/DELETE_BUTTON_CLICK';
